const safelyParseJSON = (json: string): unknown | undefined => {
  let parsed;
  // value is already JSON
  if (typeof json === 'object') {
    return json;
  }
  try {
    parsed = JSON.parse(json);
  } catch (_e) {
    parsed = undefined;
  }

  return parsed;
};

export = safelyParseJSON;
